import { StatusInfo } from './services.types';

export const HELP_GUIDE_ID = 31;
export const DEFAULT_SUBJECT_ID = 12;
export const DEFAULT_MATURITY = 3;
export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const MATURITY = {
  KM: 0,
  DATE: 1,
  KM_AND_DATE: 2,
  WORK_HOURS: 5,
} as const;

const STATUS_INFO: Record<number, StatusInfo> = {
  0: {
    label: 'در مهلت',
    tag: 'ok',
    text: 'هنوز برای انجام این سرویس مهلت دارید',
  },
  1: {
    label: 'نزدیک به سررسید',
    tag: 'warn',
    text: 'فرصت کمی تا انجام این سرویس باقی مانده است',
  },
  2: {
    label: 'گذشته از موعد',
    tag: 'bad',
    text: 'زمان انجام این سرویس گذشته است',
  },
};

const UNKNOWN_STATUS: StatusInfo = { label: '- - -', tag: '', text: '' };

const DIGIT_MAP: Record<string, string> = {
  ...Object.fromEntries([...'۰۱۲۳۴۵۶۷۸۹'].map((digit, index) => [digit, String(index)])),
  ...Object.fromEntries([...'٠١٢٣٤٥٦٧٨٩'].map((digit, index) => [digit, String(index)])),
};

export function toEnglishDigits(value: unknown): string {
  return String(value ?? '').replace(/[۰-۹٠-٩]/g, (digit) => DIGIT_MAP[digit]);
}

export function getStatusInfo(iStatus: unknown): StatusInfo {
  if (iStatus == null) return UNKNOWN_STATUS;
  return STATUS_INFO[Number(iStatus)] ?? UNKNOWN_STATUS;
}

export function isBlank(value: unknown): boolean {
  return value === null || value === undefined || value === '' || Number(value) === 0;
}

export function stripCommas(value: unknown): unknown {
  return typeof value === 'string' ? value.replace(/,/g, '') : value;
}

export function applyMaturityRules(payload: Record<string, any>): void {
  switch (Number(payload['tiMaintenanceMaturity'])) {
    case MATURITY.DATE:
      payload['iKM'] = 0;
      break;
    case MATURITY.KM:
      payload['strDate'] = '';
      break;
    case MATURITY.KM_AND_DATE:
      break;
    default:
      payload['strDate'] = '';
      payload['iKM'] = 0;
  }
}

export function validationError(payload: Record<string, any>): string | null {
  const maturity = Number(payload['tiMaintenanceMaturity']);

  if (
    (maturity === MATURITY.KM || maturity === MATURITY.KM_AND_DATE) &&
    isBlank(payload['iKM'])
  ) {
    return 'لطفا مقدار کیلومتر را وارد کنید';
  }
  if (maturity === MATURITY.DATE && payload['strDate'] === '') {
    return 'لطفا مقدار زمان را وارد کنید';
  }
  if (maturity === MATURITY.WORK_HOURS && isBlank(payload['iWorkHours'])) {
    return 'لطفا ساعت خودرو را وارد کنید';
  }
  return null;
}
